import { BrowserRouter, Routes, Route } from "react-router-dom";
import SalePage from "./pages/SalePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* /sale/:domain/:path */}
        <Route path="/:pagePath" element={<SalePage />} />
        <Route path="/" element={<SalePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
